///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportPointPromotion = Meevo.Plugins.Reports.IReportPointPromotion;
    import IReportService = Meevo.Plugins.Reports.IReportService;

    interface ICriteria {
        IncludeActive: boolean;
        IncludeInactive: boolean;
        IsCompleted: boolean;
    }

    export class ReportPointPromotionsCollection extends SmartMoverApiCollection<IReportPointPromotion> implements IApiCollection<IReportPointPromotion> {

        constructor(connectedModel: ModelValueType[], items: IReportService[] = [], options: ICollectionOptions<IReportService> = {}) {
            super(connectedModel, items, options);
        }

        protected criteria: ICriteria;

        protected get url() {
            return 'Report/PointPromotionCampaign';
        }

        protected criteriaIsValid() {
            return !(
                typeof this.criteria.IncludeActive !== 'boolean'
                || typeof this.criteria.IncludeInactive !== 'boolean'
                || typeof this.criteria.IsCompleted !== 'boolean'
            );
        }

        public resetCollection(data: ModelValueType[]): void {
            if (!this.responseList || this.responseList.length === 0) {
                return;
            }
            super.resetCollection(data);
        }
    }

}